<div class="cc-grid-container">
  <div class="cc-image-container">
    <img
      src="https://assets.oneweb.mercedes-benz.com/plugin/owcc/assets/images/404.jpg"
      alt="Error Page 404"
      loading="lazy"
      width="auto"
      height="auto"
    />
  </div>

  <!-- display different translations for different error types -->
  <ng-container *ngIf="currentErrorMajorType" [ngSwitch]="currentErrorMajorType">
    <cc-error-type-resolve-baumuster
      *ngSwitchCase="'resolveBaumuster'"
      (showLoadingSpinner)="showLoadingSpinner($event)"
    />
    <ng-container *ngSwitchDefault>
      <div class="cc-error__container">
        <div class="cc-error__info">
          <ccwb-heading size="m">{{ headline }}</ccwb-heading>
          <ccwb-text size="l">{{ description }}</ccwb-text>
          <br />
        </div>
        <div class="cc-error__actions">
          <ccwb-button [href]="homeUrl$ | async" variant="primary" size="s" theme="dark">
            {{ primaryAction }}
          </ccwb-button>
        </div>
      </div>
    </ng-container>
  </ng-container>

  <!-- fallback: if the translation file could not be loaded or the params are missing or incorrect -->
  <ng-container *ngIf="!currentErrorMajorType">
    <div class="cc-error__info">
      <ccwb-heading size="m" tag="h3">Sorry!</ccwb-heading>
      <ccwb-text size="l" tag="p"
        >An unexpected error occurred while loading the Mercedes-Benz Car Configurator. We could not find this page.
        Please visit the model overview to start your configuration.</ccwb-text
      >
    </div>
    <div class="cc-error__actions">
      <ccwb-button [href]="defaultHomeUrl" variant="primary" size="s" theme="dark"> Start Configuration </ccwb-button>
    </div>
  </ng-container>
</div>

<cc-loading-spinner *ngIf="loadingSpinnerVisible$ | async" position="absolute" />
<cc-modal-host />
